import config from ".";

export const DEFAULT_PAYMENT_PROVIDER = "stripe";
export const DEFAULT_COD_BUTTON_LABEL = "Confirm Cash on Delivery";
export const DEFAULT_STRIPE_BUTTON_LABEL = "Pay Online / Card";
export const DEFAULT_PAYPAL_BUTTON_LABEL = "Paypal";
export const DEFAULT_UPI_BUTTON_LABEL = "UPI";
export const DEFAULT_FLASH_SCREEN_COUPON = "STUH10";
export const DEFAULT_PLACE_ORDER_SCREEN_COUPON = "STUH10";
export const DEFAULT_FLASH_SCREEN_HEADING =
  "Free Delivery & Unlock upto £ 5 Cashback";

//Vendor Specific Data

export const CONTACT_DETAIL = {
  india: {
    caller_no: "+918743870503",
    whatsapp: "+918743870503",
    office_address: "Kort Ward 7, Nichlaul Maharajganj, UP",
    no_reply_email: "noreply@agrocroft.com",
    support_email: "customersupport@agrocroft.com",
    store_calling_time: "Call Us 8 Am to 6 Pm",
  },
  united_kingdom: {
    caller_no: "+4401707269944",
    whatsapp: "+4401707269944",
    office_address: "Town-Center Hatfield",
    no_reply_email: "aarohfood@gmail.com",
    support_email: "arrohfood@gmail.com",
    store_calling_time: "Call Us 8 Am to 6 Pm",
  },
};
export const DEFAULT_CALLER_NO = CONTACT_DETAIL.united_kingdom.caller_no;
export const DEFAULT_WHATSAPP = CONTACT_DETAIL.united_kingdom.whatsapp;
export const DEFAULT_NO_REPLY_EMAIL =
  CONTACT_DETAIL.united_kingdom.no_reply_email;
export const DEFAULT_SUPPORT_EMAIL =
  CONTACT_DETAIL.united_kingdom.support_email;
export const DEFAULT_OFFICE_ADDRESS =
  CONTACT_DETAIL.united_kingdom.office_address;
export const DEFAULT_CALLING_TIME =
  CONTACT_DETAIL.united_kingdom.store_calling_time;

export const METATAGS_TITLE = "Home-Agrocroft";
export const METATAGS_CONTENT =
  "Agrocroft - Your go-to online store for same-day delivery of quality agricultural products. Shop fresh produce, organic items, and more, delivered to your doorstep within hours. Experience fast, reliable, and convenient shopping with Agrocroft.";

export const METATAGS_TITLE_ICON = "./../public/favicon.png";
export const BRAND_LOGO = "/images/agro_logo2.png";

// Vendor Specific Data end here

export const HOME_PAGE_LISTING_SIZE = 18;
export const HOME_PAGE_SEARCH_LISTING_SIZE = 12;
export const HOME_PAGE_DEFAULT_GROUP_OBJECT_ID = "66644c6e84ea229fc8ee4ecf";

const imageCacheUrl = config.images.cacheUrl;
export const IMAGE_CACHE_URL_BANNER = imageCacheUrl + "/";
export const BANNER_IMAGES_ARR = [
  "home_banner/agro_banner1.jpg",
  "home_banner/agro_banner2.jpg",
];
